import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useFormData } from "./useFormData";
import { useAppDispatch } from "../../../store";
import { setSuccessMessage } from "../../../acions/actionsCreators/messageActions";
import WorkTasksService from "../../../services/workTasks";
import { TASK_WAS_CLOSED } from "../../../lib/constants";

export const useCloseTask = (
  id: string,
  form: FormInstance,
  errors: string[] | null,
  reload: () => void,
  close: () => void
) => {
  const dispatch = useAppDispatch();

  const [isClosing, setIsClosing] = useState<boolean>(false);

  const { getFormData } = useFormData();

  const onTaskClosed = useCallback(() => {
    setIsClosing(false);
    reload();
    close();
  }, [close, reload]);

  const submit = useCallback(async () => {
    try {
      const req = await form.validateFields();

      if (!errors) {
        setIsClosing(true);

        const formData = getFormData(req);

        await WorkTasksService.closeTask(id, formData);

        dispatch(setSuccessMessage(TASK_WAS_CLOSED));
        onTaskClosed();
      }
    } catch {
      setIsClosing(false);
    }
  }, [form, errors, getFormData, id, dispatch, onTaskClosed]);

  return { submit, isClosing };
};
